import React from "react";
import PropTypes from "proptypes";

import TripList from "./../../lib/triplist/TripList";

const PendingApproval = ({ user, setParentState, setAppState, handleRouting }) => (
  <div className="row">
    <div className="col-md-12">
      <h2>Thank you for applying to GIVE!</h2>
      <p className="body-text">
        Your application is pending! If you do not receive an email within 3-5
        days, please email us at info@givevolunteers.org, but in the meantime,
        here are some of the possible trips you might like to consider.{" "}
        <strong>Click the icons below to view the available dates.</strong>
      </p>
      <TripList
        user={user}
        setParentState={setParentState}
        setAppState={setAppState}
        handleRouting={handleRouting}
      />
    </div>
  </div>
);

PendingApproval.propTypes = {
  user: PropTypes.object,
  setParentState: PropTypes.func.isRequired,
  setAppState: PropTypes.func.isRequired,
  handleRouting: PropTypes.func.isRequired,
};

export default PendingApproval;
